import React from "react"
import { Tooltip } from "@mui/material"
import dayjs from "dayjs"
import { DATE_FORMAT_SHOW } from "src/utils/constants"
import {
    formatDecimalCaseReplaceDot,
    formatDecimalCaseWithComma,
    formatStringToFloatDecimalCase,
} from "src/utils/format-decimal"

const renderWithTooltip = (value) => (
    <Tooltip title={value || ""} placement="bottom-start">
        <span style={{ whiteSpace: "pre-line" }}>{value}</span>
    </Tooltip>
)

const formatDate = (value) => {
    const parsedDate = dayjs(value)
    return parsedDate.isValid() ? parsedDate.format(DATE_FORMAT_SHOW) : ""
}

const formatDecimal = (value) =>
    formatStringToFloatDecimalCase(formatDecimalCaseReplaceDot(value))

export const columnsAtualizacaoSpreads = (date) => [
    {
        field: "DataReferencia",
        headerName: "Data Referência",
        minWidth: 130,
        valueGetter: () => date,
        valueFormatter: () => formatDate(date),
    },
    { field: "CETIP", headerName: "CETIP", minWidth: 120 },
    { field: "TipoAtivo", headerName: "Tipo", minWidth: 100 },
    {
        field: "Devedor",
        headerName: "Devedor",
        minWidth: 200,
        renderCell: (params) => renderWithTooltip(params.value),
    },
    {
        field: "GrupoEconomico",
        headerName: "Grupo Econômico",
        minWidth: 200,
        renderCell: (params) => renderWithTooltip(params.value),
    },
    {
        field: "Setor",
        headerName: "Setor",
        minWidth: 180,
        renderCell: (params) => renderWithTooltip(params.value),
    },
    {
        field: "SubSetor",
        headerName: "Subsetor",
        minWidth: 140,
        renderCell: (params) => renderWithTooltip(params.value),
    },
    {
        field: "ValidadeRating",
        headerName: "Validade Rating",
        minWidth: 140,
        valueFormatter: (params) => formatDate(params.value),
    },
    {
        field: "Duration",
        headerName: "Duration",
        minWidth: 110,
        type: "number",
        renderCell: (params) => formatDecimalCaseWithComma(params.value),
    },
    {
        field: "SpreadAtual",
        headerName: "Spread Atual",
        minWidth: 120,
        type: "number",
        renderCell: (params) => formatDecimal(params.value),
    },
    {
        field: "SpreadAnterior",
        headerName: "Spread Anterior",
        minWidth: 135,
        type: "number",
        renderCell: (params) => formatDecimal(params.value),
    },
    {
        field: "DeltaSpread",
        headerName: "Delta Spread",
        minWidth: 120,
        type: "number",
        renderCell: (params) => formatDecimal(params.value),
    },
    {
        field: "SpreadsNegociadosReferencia",
        headerName: "Spreads Negociados Referência",
        minWidth: 210,
        type: "number",
        renderCell: (params) => formatDecimal(params.value),
    },
    {
        field: "VarPUMTM",
        headerName: "Var PUMTM",
        minWidth: 110,
        type: "number",
        renderCell: (params) => formatDecimal(params.value),
    },
    {
        field: "IndiceLiquidez",
        headerName: "Índice de Liquidez",
        minWidth: 140,
        type: "number",
    },
    {
        field: "DeltaScoreRating",
        headerName: "Delta Score Rating",
        minWidth: 145,
        type: "number",
    },
    {
        field: "UltimoEventoCredito",
        headerName: "Último Evento de Crédito",
        minWidth: 300,
        renderCell: (params) => renderWithTooltip(params.value),
    },
    {
        field: "AnaliseCreditoEmissao",
        headerName: "Análise Crédito Emissão",
        minWidth: 300,
        sortable: false,
        renderCell: (params) => renderWithTooltip(params.value),
    },
    {
        field: "AnaliseCreditoDevedor",
        headerName: "Análise Crédito Devedor",
        minWidth: 300,
        sortable: false,
        renderCell: (params) => renderWithTooltip(params.value),
    },
    {
        field: "AnaliseSpreadIndicativo",
        headerName: "Análise Spreads Indicativos",
        minWidth: 300,
        sortable: false,
        renderCell: (params) => renderWithTooltip(params.value),
    },
]
